import isHttpProtocol from 'utils/methods/isHttpProtocol';

const MAX_URL_LENGTH = 2048;

export default function isValidUrl(string) {
  if (typeof string !== 'string' || string.length > MAX_URL_LENGTH) {
    return false;
  }

  let url = null;

  try {
    url = new URL(string);
  } catch (_) {}

  const isValidProtocol = !!url && isHttpProtocol(url.protocol);

  var pattern = new RegExp(
    '^(https?:\\/\\/)?' + // protocol
    '((([a-z\\d]([a-z\\d-]{0,61}[a-z\\d])?)\\.)+[a-z]{2,}|' + // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$', // fragment locator
    'i'
  );
  return isValidProtocol && !!pattern.test(string);
}
